module.exports = __webpack_public_path__ + "static/media/linkedin.40870f67.svg";